export default {
  data () {
    return {
      flagMobile: true
    }
  },
  methods: {
    onResize () {
      this.flagMobile = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768
    },
    isMobile () {
      return this.flagMobile
    }
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  }
}
